import {
    DIVISIONLISTAGENTFORPARTNER_SUCCESS,
    DIVISIONLISTAGENTFORPARTNER_FAILED,
    RESET_DIVISIONLISTAGENTFORPARTNER,
    LOADING_DIVISIONLISTAGENTFORPARTNER,
    NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DIVISIONLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DIVISIONLISTAGENTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DIVISIONLISTAGENTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DIVISIONLISTAGENTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};